var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19.956055,
    viewBox: "0 0 24 19.9561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M23.63 0.55C23.33 0.19 22.89 0 22.39 0C22.12 0 21.83 0.05 21.53 0.16L1.21 7.86C0.13 8.27 -0.01 8.89 0 9.22C0 9.55 0.18 10.15 1.27 10.5L5.58 12.08L7.85 17.28C8.08 18 8.56 18.5 9.17 18.66C9.31 18.7 9.45 18.72 9.59 18.72C10.09 18.72 10.59 18.5 11.03 18.09L12.91 16.32L17.5 19.48C17.92 19.79 18.37 19.95 18.81 19.95C19.7 19.95 20.41 19.3 20.61 18.29L23.94 2.22C24.07 1.56 23.96 0.97 23.63 0.55ZM7.01 11.83L12.87 8.69L8.79 12.44C8.64 12.57 8.56 12.76 8.56 12.96C8.56 12.96 8.56 12.97 8.56 12.98L8.54 15.35L7.01 11.83ZM10.07 17.07C10.03 17.11 9.98 17.14 9.94 17.17L9.96 14.29L11.73 15.51L10.07 17.07ZM22.56 1.93L19.24 18.01C19.2 18.17 19.09 18.54 18.81 18.54C18.67 18.54 18.5 18.48 18.33 18.35C18.33 18.34 18.32 18.34 18.31 18.33L13.25 14.85L10.39 12.88L17.95 5.94C18.21 5.7 18.25 5.31 18.04 5.02C17.84 4.73 17.45 4.64 17.14 4.81L6.05 10.75L1.74 9.17C1.74 9.17 1.73 9.17 1.73 9.17L22.03 1.48C22.2 1.41 22.32 1.4 22.39 1.4C22.42 1.4 22.51 1.41 22.54 1.44C22.57 1.49 22.62 1.64 22.56 1.93Z",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic_telegram.26ee942f3ed62d1f335d915b354baf84.svg";
export { ForwardRef as ReactComponent };